import AccountProfileImage from '@atoms/AccountProfileImage/AccountProfileImage';
import type { ICourseDetailsGated } from '@models/ICourseDetailsGated';
import slugify from '@utils/helpers/slugify';

const CourseDetailsGated = ({
  introductionText,
  title,
  attendees,
}: ICourseDetailsGated) => (
  <section className="component-padding bg-black-100 text-white">
    <div className="container">
      {introductionText && (
        <p className="h4 mb-[5.625rem] md:mb-20 xl:w-8/12">
          {introductionText}
        </p>
      )}
      <p className="h6">{title}</p>
      <div className="mt-10 grid grid-cols-1 gap-7.5 md:grid-cols-2 xl:w-5/12">
        {attendees?.map((attendee) => (
          <div key={slugify(attendee.name)} className="flex items-center">
            <AccountProfileImage
              image={attendee.profileImage}
              initials={attendee.initials}
            />
            <div className="ml-5 flex flex-col">
              <p className="body-three">{attendee.name}</p>
              <p className="body-four">{attendee.email}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default CourseDetailsGated;
